import { CampaignCopilot } from './components/CampaignCopilot';
import { GuidingPrinciples } from './components/GuidingPrinciples';
import { Hero } from './components/Hero';
import { Journey } from './components/Journey';
import { Supporters } from './components/Supporters';
import { VisionCta } from './components/VisionCta';

/** Each section owns its bottom padding. */
export const PageBody = () => {
	return (
		<div>
			<Hero />
			<GuidingPrinciples />
			<CampaignCopilot />
			<Journey />
			<Supporters />
			<VisionCta />
		</div>
	);
};
